import { IRecordType } from 'types/recordType';
import { getRecordTypeSlug } from 'utils/recordTypeSlug';

/**
 * Utility function to open a record in a new tab.
 * @param recordId {String}
 * @param recordTypeId {String}
 */
export const openInANewTabDFVAction = (recordId: string, recordType: IRecordType) => {
    const tenantUrl = localStorage.getItem('tenantPath');
    if (!tenantUrl || !recordId || !recordType) return;
    window.open(
        `${tenantUrl}/data-focus-view/${getRecordTypeSlug(recordType.name)}?recordId=${recordId}&recordType=${recordType.id}`,
        '_blank'
    );
};

/**
 * Utility function to open a record in the current tab.
 * @param recordId {String}
 * @param recordTypeId {String}
 */
export const openInThisTabDFVAction = (recordId: string, recordType: IRecordType) => {
    const tenantUrl = localStorage.getItem('tenantPath');
    if (!tenantUrl || !recordId || !recordType) return;
    window.location.href = `${tenantUrl}/data-focus-view/${getRecordTypeSlug(recordType.name)}?recordId=${recordId}&recordType=${
        recordType.id
    }`;
};
